export const language = {
  gu: {
    "Har Ghar Tiranga": "Har Ghar Tiranga",
    // Download: "ડાઉનલોડ",
    "Invite on Facebook": "Invite on Facebook",
    // "Share on Facebook": "ફેસબુક પર શેર કરો",

    "Invite on Twitter": "Invite on Twitter",
    "Choose Image": "Choose Image",
    // "Share on Twitter": "ટ્વીટર પર શેર કરો",
    Monuments: "સ્મારક",
    "Create a selfie by uploading your picture and selecting one of the monuments shown below.":
      "તમારો ફોટો અપલોડ કરો અને નીચે ઉપલબ્ધ સ્મારકોમાંથી કોઈ પણની પસંદગી કરીને તમારી સેલ્ફી લો. ",
    "For better experience, please upload a clear image of your torso and above (above waist), facing the camera":
      "શ્રેષ્ઠ અનુભવ માટે કેમેરાની સામે ઊભા રહીને કમર સુધીનો સ્પષ્ટ ફોટો પાડો. ",
    "Please select a Monument": "સ્મારક પસંદ કરો",
    "Please select an image to proceed.": "Please select an image to proceed.",
    // Camera: "કેમેરા",
    // "Upload picture": "સ્મારક પસંદ કરો",
    Next: "Next",
    // Crop: "કાપો",
    "Celebrate India’s 75th Independence Day by colouring your social media profile pictures with the Tiranga!":
      "Celebrate India’s 75th Independence Day by colouring your social media profile pictures with the Tiranga!",
    "Take selfies with iconic historical monuments adorned in Tiranga or customize your selfie with the national flag.":
      "Take selfies with iconic historical monuments adorned in Tiranga or customize your selfie with the national flag.",
    "Choose monuments": "Choose monuments",
    "Snap a selfie of yourself ideally above the torso.":
      "Snap a selfie of yourself ideally above the torso.",
    "Place your photo within the cropped area.":
      "Place your photo within the cropped area.",
    "Choose the right distance for your selfie based on the effect you choose":
      "Choose the right distance for your selfie based on the effect you choose",
    "Uploaded Image": "Uploaded Image",
    Submit: "Submit",
    OK: "ઓકે",
    "Aa Gujarat Main Banaavyu Che": "આ ગુજરાત અમે બનાવ્યું છે.",
    "Gujarat is also the land where Shri Narendrabhai Modi sowed the seeds of 'Sab ka Saath, Sab ka Vikas'.":
      "ગુજરાત એ જ ધરતી જ્યાં શ્રી નરેન્દ્રભાઈ મોદીએ “સૌના સાથ, સૌના વિકાસ” ના બીજ રોપ્યાં હતાં.",
    "Gujarat is the land of Gandhi & Sardar.":
      "ગુજરાત એટલે ગાંધી અને સરદારની ભૂમિ.",
    "Six crore Gujaratis and Narendrabhai worked hard, together for over two decades to build this Gujarat. As a result, today, Gujarat is known as the country's development model.":
      "આજનું ગુજરાત છ કરોડ ગુજરાતીઓ અને નરેન્દ્રભાઈના સખત પરિશ્રમનું ફળ છે, જેને કારણે જ આજે ગુજરાત દેશનું વિકાસ મોડેલ કહેવાય છે.",
    'Come be a part of the campaign: “I have built this Gujarat"':
      "આવો તમે પણ ભાગ બનો “આ ગુજરાત મેં બનાવ્યું છે” અભિયાનનો.",
    "Click a selfie on this platform and post it on social media. And, proudly say: “I have built this Gujarat.”":
      "આ પ્લેટફોર્મ પર આવી સેલ્ફી ક્લિક કરો અને તેને સોશિયલ મીડિયા પર પોસ્ટ કરો. અને ગર્વથી કહોઃ “આ ગુજરાત મેં બનાવ્યું છે.",
    "/assets/images/en_logo.png": "/assets/images/logo.png",
    "The world's tallest statue, the world's largest cricket stadium, the world's largest hybrid energy park, the country's first riverfront, the country's first bullet train, the country's first centre for traditional medicine, the country's first in-space headquarters - these are just a few monuments of pride for every Gujarati.":
      "વિશ્વની સૌથી ઉંચી પ્રતિમા, વિશ્વનું સૌથી મોટું ક્રિકેટ સ્ટેડિયમ, વિશ્વનો સૌથી વિશાળ હાયબ્રિડ એનર્જી પાર્ક, દેશનો પહેલો રિવરફ્રન્ટ, દેશની પહેલી બુલેટ ટ્રેન, દેશનું પહેલું સેન્ટર ફોર ટ્રેડીશનલ મેડિસીન, દેશનું પહેલું ઇન સ્પેસ હેડક્વાર્ટર – આ બધાં સ્મારકો ગુજરાતીઓના ગર્વના પ્રતિક છે.",
  },
};
